module.exports = __webpack_public_path__ + "static/media/the-game-aflw-2024.335dc856.png";